import { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { LuPresentation } from "react-icons/lu";
import TopPageTitle from "../../../components/TopPageTitle/TopPageTitle";
import Loader from "../../../components/Loader/Loader";
import { PagesWrapper } from "../../../styles/components/PagesWrapper.styled";
import * as styled from "../../../components/MaterialsLevel/MaterialsLevel.styled";
import { courseOf, levelLabel, fetchPlatformLessons, platformLessonUrl } from "../../../helpers/materials/platformLessons";
import axios from "../../../axios";

// «Матеріали → Уроки платформи → група → рівень»: уроки по юнітах книжки (Lead-in, Unit 1 …), клік — презентація
function PlatformLessons({ isAdmin }) {
  const { group, level } = useParams();
  const lang = useSearchParams()[0].get("lang"); // не англійська — курс з префіксом мови
  const [lessons, setLessons] = useState(null);

  useEffect(() => {
    fetchPlatformLessons(courseOf(group, level, lang))
      .then(setLessons)
      .catch(() => setLessons([]));
  }, [group, level, lang]);

  if (!lessons) return <Loader />;

  return (
    <PagesWrapper>
      <PlatformLessonList title={`Уроки платформи · ${levelLabel(level)}`} lessons={lessons} isAdmin={isAdmin} />
    </PagesWrapper>
  );
}

// Список уроків курсу по юнітах — і для вчителя/адміна, і в «Матеріалах» учня на платформі
export function PlatformLessonList({ title, englishLevel, lessons, isAdmin, children }) {
  // Адміну — середня оцінка уроку від дітей (слайд «¿Te gustó la clase?»): { lessonId: { avg, count, low } }
  const [ratings, setRatings] = useState({});
  useEffect(() => {
    if (!isAdmin) return;
    axios.get("admin/lesson-ratings").then(({ data }) => setRatings(data || {})).catch(() => setRatings({}));
  }, [isAdmin]);

  // Юніти в порядку уроків
  const units = [];
  lessons.forEach((lesson) => {
    const name = lesson.unit || "Уроки";
    let unit = units.find((u) => u.name === name);
    if (!unit) units.push((unit = { name, title: lesson.unitTitle, lessons: [] }));
    unit.lessons.push(lesson);
  });

  return (
    <>
      <TopPageTitle value={title} englishLevel={englishLevel} />
      <styled.MaterialsWrapper>
        {units.length === 0 && <p>Для цього рівня ще немає уроків платформи.</p>}
        {units.map((unit) => (
          <styled.TopicWrapper key={unit.name}>
            <styled.TopicName>
              {unit.name}
              {unit.title ? ` · ${unit.title}` : ""}
            </styled.TopicName>
            <styled.List>
              {unit.lessons.map((lesson, index) => (
                <styled.Item key={lesson._id} isAlternate={index % 2 !== 0}>
                  {/* Урок — в окремій вкладці, щоб не перекривати кабінет */}
                  <styled.LessonName as={Link} to={platformLessonUrl(lesson.lessonId)} target="_blank" rel="noopener">
                    <span>
                      {lesson.course?.endsWith("-trial") ? "Пробний урок" : `Lesson ${lesson.number}`}
                      <br />
                      <small>
                        {lesson.code && lesson.code !== unit.name ? `${lesson.code} · ` : ""}
                        {lesson.title}
                      </small>
                    </span>
                    <LuPresentation size={16} />
                  </styled.LessonName>
                  {isAdmin && lesson.status !== "published" && <styled.Draft>чернетка</styled.Draft>}
                  {isAdmin && ratings[lesson.lessonId] && (
                    <styled.Draft title={`Оцінка дітей: ${ratings[lesson.lessonId].count} оцінок, з них 1–2★: ${ratings[lesson.lessonId].low}`}>
                      ★ {ratings[lesson.lessonId].avg} ({ratings[lesson.lessonId].count})
                    </styled.Draft>
                  )}
                </styled.Item>
              ))}
            </styled.List>
          </styled.TopicWrapper>
        ))}
        {children}
      </styled.MaterialsWrapper>
    </>
  );
}

export default PlatformLessons;
